import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectSettingsIssueTypesRoute: InvariantJiraRoute = {
	name: 'legacy-project-settings-issue-types',
	path: '/plugins/servlet/project-config/:projectKey/issuetypes',
};
